<template>
  <div class="component-form-login">
    <div class="title title-form title-info text-center">
      <template v-if="!forgot"><strong>LOGIN</strong></template>
      <template v-else="">RECUPERAR <strong>SENHA</strong></template>
    </div>
    <div class="subtitle" v-if="forgot">
      <div class="space-10"></div>
      <template>Informe o seu e-mail cadastrado para recuperar a senha.</template>
    </div>
    <div class="space-20"></div>
    <div v-if="!forgot"  class="form-sign-in">
      <form @submit.prevent="doLogin()" novalidate>
        <input-email placeholder="E-mail" name="email" v-model="email" :disabled="loading" :error="errors.email"/>
        <input-password placeholder="Senha" name="password" v-model="password" :disabled="loading" :error="errors.password"/>
        <div class="space-15"></div>
        <div class="form-group text-center">
          <button :disabled="loading" class="btn btn-info bold" type="submit">
            <transition name="fade" mode="out-in">
              <span v-if="loading">ENTRANDO <i class="fa fa-fw fa-lg fa-spinner fa-spin"></i></span>
              <span v-else="">ENTRAR</span>
            </transition>
          </button>
          <div class="space-20"></div>
          <a href="#" class="btn btn-link" @click="swap('forgot')">Esqueceu sua senha?</a>
        </div>
      </form>
    </div>
    <div v-if="forgot && !forgotSent" class="form-forgot-password">
      <form @submit.prevent="forgotPassword()" novalidate>
        <div class="row">
          <div class="col-md-8 col-md-offset-2">
            <input-email placeholder="E-mail" name="email" v-model="email" :error="errors.email"/>
          </div>
        </div>
        <div class="space-10"></div>
        <div class="form-group text-center">
          <button :disabled="loading" class="btn btn-purple bold" type="submit">
            <transition name="fade" mode="out-in">
              <span v-if="loading">Aguarde <i class="fa fa-fw fa-lg fa-spinner fa-spin"></i></span>
              <span v-else="">Recuperar senha</span>
            </transition>
          </button>
          <button @click="swap('login')" class="btn btn-default" type="button">Cancelar</button>
        </div>
      </form>
    </div>
    <div v-if="forgotSent" class="text-center">
      <transition name="fade" mode="out-in">
        <div>
          <h4>Solicitação recebida!</h4>
          <p>{{ forgotMessage }}</p>
        </div>
      </transition>
    </div>

    <modal-bootstrap title="Temos de uso e políticas de privacidade" footer="" :auto-height="auto" v-if="modalOpened"
                     :show="modalOpened"
                     @close="cancelLogin"
    >
          A política de privacidade e/ou os termos de uso foram atualizados,
          para continuar você precisa ler e aceitar os novos
          <router-link :to="{ name: 'use_terms' }" target="_blank">termos de uso</router-link> e as
          <router-link :to="{ name: 'privacy_policy' }" target="_blank">políticas de privacidade</router-link>.
      <hr>
      <div class="text-right">
        <button class="btn btn-danger white" @click="cancelLogin">Cancelar</button>
        <button class="btn btn-default" @click="acceptTerms">Aceitar</button>
      </div>
    </modal-bootstrap>
  </div>
</template>

<script>
  import * as config from '../../config.js'
  import * as env from '../../env'
  import {mapState, mapActions} from 'vuex'
  import InputPassword from './../../components/forms/inputs/InputPassword'

  export default{
    name: 'FormLogin',
    components: {
      InputPassword
    },
    props: [],
    data () {
      return {
        email: '',
        password: '',
        loginError: false,
        loading: false,
        errors: {},
        forgot: false,
        forgotSent: false,
        forgotMessage: false,
        modalOpened: false
      }
    },
    computed: {
      ...mapState({
        user: state => state.user
      })
    },
    watch: {
      'email' (to, from) {
        if (to !== '') {
          this.errors.email = false
        } else {
          this.$set(this.errors, 'email', 'O e-mail é obrigatório')
        }
      },
      'password' (to, from) {
        if (to !== '') {
          this.errors.password = false
        } else {
          this.$set(this.errors, 'password', 'A senha é obrigatória')
        }
      }
    },
    mounted () {
      // window.$('.form-sign-in input[name=email]').focus()
    },
    methods: {
      cancelLogin () {
        this.modalOpened = false
        this.unsetUser()
      },
      acceptTerms () {
        this.$http.post('users/accept-terms')
            .then(response => {
              this.saveUser(response.data)
              this.$emit('logged', response.data)
              this.loading = false
              this.modalOpened = false
            }, _ => {
              this.cancelLogin()
            })
      },
      swap (to) {
        this.errors = {}
        if (to === 'login') {
          this.forgot = false
          setTimeout(() => {
            window.$('input[name=email]', this.$el).focus()
          })
        } else {
          this.forgot = true
          setTimeout(() => {
            window.$('input[name=email]', this.$el).focus()
          })
        }
      },
      doLogin () {
        this.loginError = false
        this.errors = {}
        let error = false
        if (this.email === '') {
          this.$set(this.errors, 'email', 'O e-mail é obrigatório')
          window.$('input[name=email]', this.$el).focus()
          error = true
        }
        if (this.password === '') {
          this.$set(this.errors, 'password', 'A senha é obrigatória')
          if (!error) window.$('input[name=password]', this.$el).focus()
          error = true
        }
        if (error) return
        const postData = {
          grant_type: 'password',
          client_id: env.clientId,
          client_secret: env.clientSecret,
          username: this.email,
          password: this.password,
          scope: ''
        }
        this.loading = true
        this.$http.post(config.loginURL, postData)
          .then(response => {
            this.saveUser(response.data)
            this.$http.get(config.userURL)
              .then(response => {
                if (response.data.hasToBeAcceptTermsAndPrivacy === true) {
                  this.modalOpened = true
                  this.loading = false
                } else {
                  this.saveUser(response.data)
                  this.$emit('logged', response.data)
                  this.loading = false
                }
              })
          }, error => {
            this.loading = false
            const translatedErrors = []
            translatedErrors['invalid_grant'] = 'Dados inválidos!'
            this.errors.password = translatedErrors[error.data.error]
            window.$('input[name=password]', this.$el).select()
          })
      },
      forgotPassword () {
        this.errors = {}
        let error = false
        if (this.email === '') {
          this.$set(this.errors, 'email', 'O e-mail é obrigatório')
          window.$('input[name=email]', this.$el).focus()
          error = true
        }
        if (error) return
        this.loading = true
        const postData = {
          email: this.email
        }
        this.$http.post(config.passwordEmailURL, postData)
          .then(response => {
            this.loading = false
            this.forgotSent = true
            this.forgotMessage = response.data.message
            let self = this
            setTimeout(function () {
              self.forgotSent = false
              self.swap('login')
            }, 10000)
          }, error => {
            this.loading = false
            if (error.data.error === 'Validation error') {
              this.errors = error.data.errors
              window.$('input[name=' + Object.keys(this.errors)[0] + ']', this.$el).focus()
            }
          })
      },
      ...mapActions(['saveUser', 'unsetUser'])
    }
  }
</script>



// WEBPACK FOOTER //
// FormLogin.vue?4a6f7aa3